<template>
<EntityReport entity="ReportDanger" />
</template>

<script>
export default {

}
</script>
